// Browser pose tracking (MediaPipe Pose) for the Skeletal HUD. Wasm + model stream from CDN and are cached by the browser.
let landmarkerP = null;

const WASM = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@1.0.1/wasm";
const MODEL = "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_full/float16/1/pose_landmarker_full.task";

export const preloadPose = () => {
  if (!landmarkerP) {
    landmarkerP = (async () => {
      const { FilesetResolver, PoseLandmarker } = await import("@mediapipe/tasks-vision");
      const fileset = await FilesetResolver.forVisionTasks(WASM);
      const opts = (delegate) => ({ baseOptions: { modelAssetPath: MODEL, delegate }, runningMode: "IMAGE", numPoses: 1, minPoseDetectionConfidence: 0.4 });
      try { return await PoseLandmarker.createFromOptions(fileset, opts("GPU")); }
      catch (e) { return await PoseLandmarker.createFromOptions(fileset, opts("CPU")); }
    })().catch((e) => { landmarkerP = null; throw e; });
  }
  return landmarkerP;
};

// 13-point biomechanical rig, keyed for the HUD. Values are normalized to the video frame.
const RIG = {
  head: 0, lsho: 11, rsho: 12, lelb: 13, relb: 14, lwri: 15, rwri: 16,
  lhip: 23, rhip: 24, lknee: 25, rknee: 26, lank: 27, rank: 28,
};
export const RIG_LABELS = {
  head: "HEAD", lsho: "L_SHOULDER", rsho: "R_SHOULDER", lelb: "L_ELBOW", relb: "R_ELBOW", lwri: "L_WRIST", rwri: "R_WRIST",
  lhip: "L_HIP", rhip: "R_HIP", lknee: "L_KNEE", rknee: "R_KNEE", lank: "L_FOOT", rank: "R_FOOT",
};
export const BONES = [
  ["head", "neck"], ["lsho", "rsho"], ["lsho", "lelb"], ["lelb", "lwri"], ["rsho", "relb"], ["relb", "rwri"],
  ["lsho", "lhip"], ["rsho", "rhip"], ["lhip", "rhip"], ["lhip", "lknee"], ["lknee", "lank"], ["rhip", "rknee"], ["rknee", "rank"],
];

// Returns { head: {x,y}, ... , neck: {x,y} } or null when no player is found in the frame.
export const detectPose = async (video) => {
  if (!video || !video.videoWidth) return null;
  const lm = await preloadPose();
  const res = lm.detect(video);
  const pts = res?.landmarks?.[0];
  if (!pts) return null;
  const out = {};
  let seen = 0;
  Object.entries(RIG).forEach(([k, i]) => {
    const p = pts[i];
    if (p && (p.visibility == null || p.visibility > 0.3)) { out[k] = { x: p.x, y: p.y }; seen += 1; }
  });
  if (seen < 4) return null;
  if (out.lsho && out.rsho) out.neck = { x: (out.lsho.x + out.rsho.x) / 2, y: (out.lsho.y + out.rsho.y) / 2 };
  return out;
};
